import autolistLogoRed from 'public/static/images/autolist-logo-red.png';
import defaults from './defaults';

export default class {
  // eslint-disable-next-line class-methods-use-this
  toJSON() {
    const data = {
      '@type': 'Organization',
      name: 'Autolist',
      url: 'https://www.autolist.com',
      logo: `${autolistLogoRed}`,
      sameAs: [
        'https://www.facebook.com/Autolist',
        'https://twitter.com/AutolistCom',
        'https://www.instagram.com/Autolist',
        'https://www.pinterest.com/autolistdotcom/',
        'https://plus.google.com/+Autolist',
        'https://www.youtube.com/channel/UCivpBDQorjuuKQ_ZVFmRIsw/',
        'https://www.linkedin.com/company/auto-list',
      ],
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'help@autolist.com',
        url: 'https://www.autolist.com/about-us#contact-us',
        contactType: 'customer support',
      },
    };

    return { ...defaults, ...data };
  }
}
